import {RudderAnalytics} from '@rudderstack/analytics-js'

const rudderanalytics = new RudderAnalytics()
rudderanalytics.load(
  window.rudderstack_token,
  window.rudderstack_data_plane_url,
  {}
)

export {rudderanalytics}
